export const clampMarketplaceDiscountPercent = (value: unknown) => {
  const parsed = Number(String(value ?? 0).replace(',', '.'))
  if (!Number.isFinite(parsed)) return 0
  return Number(Math.min(99.99, Math.max(0, parsed)).toFixed(2))
}

export const canShowMarketplaceAdvertiserPrice = (isLoggedIn: boolean) => isLoggedIn

export const calculateMarketplaceFinalPrice = (
  price: number | null | undefined,
  discountPercent: number | null | undefined,
) => {
  if (typeof price !== 'number' || !Number.isFinite(price) || price <= 0) return null
  const discount = clampMarketplaceDiscountPercent(discountPercent)
  return Number(Math.max(0.01, price * (1 - discount / 100)).toFixed(2))
}

export const formatMarketplaceCurrency = (value: number | null | undefined) => (
  typeof value === 'number' && Number.isFinite(value)
    ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : 'R$ 0,00'
)

export const formatMarketplaceCurrencyInput = (value: number | null | undefined) => (
  typeof value === 'number' && Number.isFinite(value)
    ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : ''
)

export const parseMarketplaceCurrencyInput = (value: string) => {
  const raw = value.replace(/[^\d.,]/g, '')
  if (!raw) return null
  const normalized = raw.includes(',')
    ? raw.replace(/\./g, '').replace(',', '.')
    : /^\d{1,3}(?:\.\d{3})+$/.test(raw)
      ? raw.replace(/\./g, '')
      : raw
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? Number(parsed.toFixed(2)) : null
}
